import { ImoClassAutoCompleteProps } from '@tom-ui/planning'
import { AllocationRuleStore } from '@yard/stores/allocation-rule.store'
import { computed, makeObservable, observable } from 'mobx'
import { ReactNode } from 'react'

export class AllocationRulesTemplateViewStore {
  constructor(
    readonly allocationRuleStore: AllocationRuleStore,
    public companyAutoComplete: (props: any) => ReactNode,
    public locationCodeAutoComplete: (props: any) => ReactNode,
    public imoClassAutoComplete: (props: ImoClassAutoCompleteProps) => ReactNode,
    public id?: string,
  ) {
    makeObservable(this, {
      id: observable,

      companyAutoComplete: observable,
      locationCodeAutoComplete: observable,
      imoClassAutoComplete: observable,

      allocationRuleTemplateId: computed,
      isEdit: computed,
      allocationRuleTemplate: computed,
    })
  }

  get allocationRuleTemplateId() {
    return this.id
  }

  get isEdit() {
    return !!this.allocationRuleTemplateId && this.allocationRuleTemplateId !== 'new'
  }

  get allocationRuleTemplate() {
    if (!this.allocationRuleStore) return

    return this.allocationRuleStore.items.find(item => item.id === this.allocationRuleTemplateId)
  }
}
